import React from "react";

interface PriorityBarsProps {
    priority: string;
}

const redColor = "#D5121E";
const greyColor = "#A8A8A8";

const PriorityBars: React.FC<PriorityBarsProps> = ({ priority }) => {
    const parsedPriority = parseInt(priority, 10);

    const firstBarFill = parsedPriority >= 1 ? redColor : greyColor;
    const secondBarFill = parsedPriority >= 2 ? redColor : greyColor;
    const thirdBarFill = parsedPriority >= 3 ? redColor : greyColor;

    return (
        <svg
            width={20}
            height={13}
            viewBox="0 0 20 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect y="7" width="4" height="6" fill={firstBarFill} />
            <rect x="8" y="3" width="4" height="10" fill={secondBarFill} />
            <rect x="16" width="4" height="13" fill={thirdBarFill} />
        </svg>
    );
};

export default PriorityBars;
